// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"57e76ef5fb03fd4093c1","777":"d13a485af2772b50b5d8"}[chunkId] + ".chunk.js";
};